import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import {
  FinancialEntityBranchesFailure,
  FinancialEntityBranchesRequest,
  FinancialEntityBranchesReset,
  FinancialEntityBranchesSuccess,
} from './actions';
import { FinancialEntityBranch } from '@models/swagger';

export const featureKey = 'financialEntityBranches';

export interface State {
  data: FinancialEntityBranch[] | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: [],
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(FinancialEntityBranchesFailure, (state, { error }) => ({ ...state, data: [], error, loading: false })),
    on(FinancialEntityBranchesRequest, state => ({ ...state, error: null, loading: true })),
    on(FinancialEntityBranchesSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false })),
    on(FinancialEntityBranchesReset, state => ({ ...state, data: [] }))
  )(state, action);
}
